import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/arrows/right_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7072 11.2929C16.0977 11.6834 16.0977 12.3166 15.7072 12.7071L10.0503 18.364C9.65982 18.7545 9.02666 18.7545 8.63613 18.364C8.24561 17.9734 8.24561 17.3403 8.63613 16.9497L13.5859 12L8.63613 7.05025C8.24561 6.65973 8.24561 6.02656 8.63613 5.63604C9.02666 5.24551 9.65982 5.24551 10.0503 5.63604L15.7072 11.2929Z"
		})
	})
});
export default SvgRightLine;
